import { useState } from "react";
import styles from "./nav-bar.module.css";

export default function NavBar() {
    const [muted, setMuted] = useState(true);

    const setGlobalMute = (state) => {
        const media = document.querySelectorAll("audio, video");
        media.forEach((el) => {
            el.muted = state;
        });
    };

    const toggleMute = () => {
        const newState = !muted;
        setMuted(newState);
        setGlobalMute(newState);
    };

    return (
        <nav className={styles.navWrap}>
            <a href="https://www.qodo.ai/bugechasegame">
                <img src="qodo-logo.svg" alt="Qodo Logo" />
            </a>
            {window.location.pathname !== "/leaderboard" && (
                <>
                    <button onClick={toggleMute} className={styles.muteBtn}>
                        {muted ? "unmute" : "mute"}
                    </button>
                    <a className={styles.lbBtn} href="/leaderboard">
                        Leaderboard
                    </a>
                </>
            ) ||
                <a className={styles.muteBtn} href="https://www.qodo.ai/bugechasegame">
                    Back
                </a>
            }
        </nav>
    );
}
